import api from './client.js'

export const visionAPI = {
  getHealth:       () => api.get('/vision/health'),
  getActiveShow:   () => api.get('/vision/active-show'),
  getGenres:       () => api.get('/vision/genres'),

  // Shows
  listShows:       () => api.get('/vision/shows'),
  createShow:      (data) => api.post('/vision/shows', data),
  updateShow:      (id, data) => api.patch(`/vision/shows/${id}`, data),
  awardResults:    (id)       => api.post(`/vision/shows/${id}/award-results`),
  deleteShow:      (id) => api.delete(`/vision/shows/${id}`),
  activateShow:    (id) => api.post(`/vision/shows/${id}/activate`),
  resetShow:       (id) => api.post(`/vision/shows/${id}/reset`),
  populateShowMock:(id) => api.post(`/vision/shows/${id}/populate`),

  // Teams
  listTeams:       (showId) => api.get(`/vision/shows/${showId}/teams`),
  createTeam:      (showId, data) => api.post(`/vision/shows/${showId}/teams`, data),
  updateTeam:      (id, data) => api.patch(`/vision/teams/${id}`, data),
  deleteTeam:      (id) => api.delete(`/vision/teams/${id}`),
  uploadTeamLogo:  (id, file) => {
    const fd = new FormData(); fd.append('file', file)
    return api.post(`/vision/teams/${id}/logo`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },

  // Entries
  listEntries:     (showId) => api.get(`/vision/shows/${showId}/entries`),
  createEntry:     (showId, data) => api.post(`/vision/shows/${showId}/entries`, data),
  updateEntry:     (id, data) => api.patch(`/vision/entries/${id}`, data),
  deleteEntry:     (id) => api.delete(`/vision/entries/${id}`),
  uploadEntryAudio:(id, file) => {
    const fd = new FormData(); fd.append('file', file)
    return api.post(`/vision/entries/${id}/audio`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },

  // Juries
  listJuries:      (showId) => api.get(`/vision/shows/${showId}/juries`),
  createJury:      (showId, data) => api.post(`/vision/shows/${showId}/juries`, data),
  updateJury:      (id, data) => api.patch(`/vision/juries/${id}`, data),
  deleteJury:      (id) => api.delete(`/vision/juries/${id}`),

  // Meta
  listEligibleUsers: () => api.get('/vision/eligible-users'),

  // Jury voting
  getMyJury:         () => api.get('/vision/jury/mine'),
  saveJuryVotes:     (votes) => api.post('/vision/jury/mine/votes', { votes }),
  submitJury:        () => api.post('/vision/jury/mine/submit'),
  getJuryProgress:   () => api.get('/vision/admin/jury-progress'),
  adminGetJuryData:  (id) => api.get(`/vision/admin/juries/${id}/votes`),
  adminSaveJuryVotes:(id, votes) => api.post(`/vision/admin/juries/${id}/votes`, { votes }),
  adminSubmitJury:   (id) => api.post(`/vision/admin/juries/${id}/submit`),

  // Publiek voting
  getMyVoteState:    () => api.get('/vision/vote/mine'),
  submitMyVote:      (votes) => api.post('/vision/vote/mine/submit', { votes }),
  getPublicVoteStats:() => api.get('/vision/admin/vote-stats'),
  adminGetPublicScores:  () => api.get('/vision/admin/public-scores'),
  adminSavePublicScores: (scores) => api.post('/vision/admin/public-scores', { scores }),

  // Stage state
  getState:          () => api.get('/vision/state'),
  updateState:       (patch) => api.post('/vision/state', patch),

  // Control view
  getControlData:    () => api.get('/vision/admin/control-data'),

  // Submissions (user)
  getMySubmission:   () => api.get('/vision/submissions/mine'),
  createMySubmission:(formData) =>
    api.post('/vision/submissions/mine', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  updateMySubmission:(id, data) => api.patch(`/vision/submissions/mine/${id}`, data),
  replaceMyAudio:    (id, file) => {
    const fd = new FormData(); fd.append('file', file)
    return api.post(`/vision/submissions/mine/${id}/audio`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  deleteMySubmission:(id) => api.delete(`/vision/submissions/mine/${id}`),
  withdrawMySubmission:(id) => api.post(`/vision/submissions/mine/${id}/withdraw`),

  // Submissions (admin)
  listAdminSubmissions: () => api.get('/vision/admin/submissions'),
  approveSubmission:    (id) => api.post(`/vision/admin/submissions/${id}/approve`),
  rejectSubmission:     (id, notes) => api.post(`/vision/admin/submissions/${id}/reject`, { notes }),
  adminWithdrawSubmission: (id) => api.post(`/vision/admin/submissions/${id}/withdraw`),
}
